import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'
import { PERMISSION_DEFINITIONS } from '@/lib/permissions'

/** @typedef {import('@/types/api').DiscountReason} DiscountReason */

export const DISCOUNT_PERMISSION_OPTIONS = PERMISSION_DEFINITIONS.filter((permission) =>
  ['pos', 'admin'].includes(permission.group),
).map((permission) => ({
  value: permission.slug,
  label: `${permission.name} (${permission.slug})`,
}))

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: DiscountReason[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchDiscountReasonsPage(params = {}) {
  const { data } = await api.get('/masters/discount-reasons', { params })
  const parsed = parseMasterCatalogResponse(data, 'discount_reasons')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<DiscountReason[]>}
 */
export async function fetchDiscountReasonsList(params = {}) {
  const { data } = await api.get('/masters/discount-reasons', { params })
  return data.data.discount_reasons
}

/**
 * @returns {Promise<DiscountReason[]>}
 */
export async function fetchDiscountReasons() {
  return fetchDiscountReasonsList()
}

/**
 * @param {Partial<DiscountReason>} payload
 * @returns {Promise<DiscountReason>}
 */
export async function createDiscountReason(payload) {
  const { data } = await api.post('/masters/discount-reasons', payload)
  return data.data.discount_reason
}

/**
 * @param {number} discountReasonId
 * @param {Partial<DiscountReason>} payload
 * @returns {Promise<DiscountReason>}
 */
export async function updateDiscountReason(discountReasonId, payload) {
  const { data } = await api.put(`/masters/discount-reasons/${discountReasonId}`, payload)
  return data.data.discount_reason
}
